import { Template, Component, Attribute } from '@scoutgg/ftw/source/lib'
import template from './status.jade'
import '@scoutgg/ftw/source/atoms/toggle/toggle'
import { Match } from '../../models'
import emitter from '@scoutgg/ftw/source/services/emitter'
import '../feeds'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
@Attribute('standalone', Boolean)
@Attribute('edit', Boolean)
@Attribute('viewDashboard', Boolean)
@Attribute('overrided', Boolean)
@Attribute('filterBop', Boolean)

export default class Status extends HTMLElement {
  created() {
    this.tick = () => {
      if(this.match.status === 'live') {
        this.render()
        this.renderNext = true
      } else if(this.renderNext) {
        this.render()
        this.renderNext = false
      }
    }
  }

  attached() {
    this.unsubsribe = this.match.subscribe(() => {
      this.render()
    })
    if(this.standalone) this.update(this.match.load())
    emitter.on('match-updated', () => {
      this.update(this.match.load())
      this.render()
    })
    this.interval = setInterval(this.tick, 1000)
  }
  detached() {
    if(this.unsubsribe) this.unsubsribe()
    clearInterval(this.interval)
  }
  toggleHidebop() {
    this.filterBop = !this.filterBop
    this.emit('toggle-bop', { filterBop: this.filterBop })
    this.render()
  }
  get score() {
    return (this.match && this.match.score) || [0, 0]
  }
  get subScore() {
    return (this.match && this.match.subScore) || [0, 0]
  }
  get phases() {
    return (this.match && this.match.phases) || [0, 0]
  }
  get phaseMax() {
    if(!this.match) return 0
    return this.match.periods || 0
  }
}
